import {ApiProvider} from "@renta-apps/athenaeum-react-common";
import ApplyForCompanyAccountRequest from "@/models/server/ApplyForCompanyAccountRequest";

export const needToCompleteStrongAuthentication = async (request: ApplyForCompanyAccountRequest): Promise<boolean> => {
        return await ApiProvider.postAsync(`/api/Account/NeedToCompleteStrongAuthentication`, request, null);
}